/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import Cookie from 'js-cookie';
import { connect } from 'react-redux';
import jwt from 'jsonwebtoken';
import PropTypes from 'prop-types';
import questionBg from '../../template/utils/images/questionBg.png';
import SelectAccountId from './SelectAccountId';
import withdrawFixTipInvestment, { deleteWithdrawFixTipInvestmentError } from '../../actions/investment.actions/mtLipActions/withdrawFixTip';
import { ErrorAlertNotification } from '../commons/index';
import withdrawMtLipInvestment, { deleteWithdrawMtLipInvestmentError } from '../../actions/investment.actions/mtLipActions/postMtLipWithdraw';

/**
 * @class WithDrawInvestOption
 */
class WithDrawInvestOption extends Component {

  withDrawToWallet = () => {
    const getInvestObj = Cookie.getJSON('investObj');
    const token = Cookie.get('jwtToken');
    const decodeToken = jwt.decode(token);
    const { customerId } = decodeToken;
    const {
      WithdrawFixTipInvestment, WithdrawMtLipInvestment
    } = this.props;
    if (getInvestObj.actionType === 'fixTipAction') {
      const obj = {
        customerId: Number(customerId),
        fixtipId: Number(getInvestObj.investmentId),
        withdrawTo: 2
      };
      WithdrawFixTipInvestment(obj);
    }
    if (getInvestObj.actionType === 'mtLipAction') {
      const obj = {
        customerId: Number(customerId),
        mtlipId: Number(getInvestObj.investmentId),
        withdrawTo: 2
      };
      WithdrawMtLipInvestment(obj);
    }
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  handleDelete = () => {
    const investActionType = Cookie.getJSON('investObj');
    if (investActionType.actionType === 'fixTipAction') {
      const { DeleteWithdrawFixTipInvestmentError } = this.props;
      DeleteWithdrawFixTipInvestmentError();
    }
    if (investActionType.actionType === 'mtLipAction') {
      const { DeleteWithdrawMtLipInvestmentError } = this.props;
      DeleteWithdrawMtLipInvestmentError();
    }
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      fixTipError,
      fixTipInvestLoading,
      mtLipError,
      mtLipInvestLoading,
    } = this.props;

    const withDrawInvestOption = (
      <div className="modal fade" id="ftop_settings">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">
                {' '}
                <span> Close </span>
                {' '}
&times;
              </button>
            </div>

            <div className="modal-body p-5">
              <div className="first_step">
                <div className="ques_info">
                  <img src={questionBg} alt="" />
                </div>
                {
                  fixTipError || mtLipError ? (
                    <ErrorAlertNotification
                      errors={fixTipError || mtLipError }
                      onClick={this.handleDelete}
                    />
                  ) : ''
                }
                <div className="have_stock_acc">
                  <p>
                        Choose your preferred withdrawal destination..
                  </p>
                </div>

                <div className="have_stock_acc_answer">

                  <div className="wallet_button mr-3" style={{
                    backgroundColor: '#99BF16',
                    borderRadius: '4px',
                  }}
                  >
                    {
                      fixTipInvestLoading || mtLipInvestLoading ? (
                        <button
                          type="button"
                          style={{
                            color: '#ffff'
                          }}
                          onClick={this.withDrawToWallet}
                        >
                          <i className="fa fa-spinner fa-spin" />
                          {'  '}
                      Wallet
                        </button>
                      ) : (
                        <button
                          type="button"
                      // data-dismiss="modal"
                          style={{
                            color: '#ffff'
                          }}
                          onClick={this.withDrawToWallet}
                        >
                      Wallet
                        </button>
                      )
                    }
                  </div>
                  <div className="ans_yes">
                    <button
                      type="button" id="yes_i_do"
                      data-toggle="modal"
                      data-target="#select_account"
                      data-dismiss="modal"
                    >
                     <span style={{ color: 'white' }}>Bank Account</span>
                    </button>
                  </div>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    );
    return (
      <>
        { withDrawInvestOption }
        <SelectAccountId />
      </>
    );
  }
}

WithDrawInvestOption.propTypes = {
  WithdrawFixTipInvestment: PropTypes.func,
  fixTipError: PropTypes.string,
  DeleteWithdrawFixTipInvestmentError: PropTypes.func,
  DeleteWithdrawMtLipInvestmentError: PropTypes.func,
  fixTipInvestLoading: PropTypes.bool,
  WithdrawMtLipInvestment: PropTypes.func,
  mtLipError: PropTypes.any,
  mtLipInvestLoading: PropTypes.bool
};

const mapStateToProps = state => ({
  fixTipError: state.withdrawFixLip.error,
  fixTipInvestLoading: state.withdrawFixLip.loading,
  mtLipError: state.withdrawMtLip.error,
  mtLipInvestLoading: state.withdrawMtLip.loading,
});

export default connect(mapStateToProps, {
  WithdrawFixTipInvestment: withdrawFixTipInvestment,
  DeleteWithdrawFixTipInvestmentError: deleteWithdrawFixTipInvestmentError,
  WithdrawMtLipInvestment: withdrawMtLipInvestment,
  DeleteWithdrawMtLipInvestmentError: deleteWithdrawMtLipInvestmentError
})(WithDrawInvestOption);
